export const iconFontAwesomeUsersPeopleHeadSideCoughSlash = (
	<i className="fa-solid fa-head-side-cough-slash"></i>
);
